"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var plans_exports = {};
__export(plans_exports, {
  billableRoles: () => billableRoles,
  computeVat: () => computeVat,
  computeWorkspaceLimits: () => computeWorkspaceLimits,
  euVatRates: () => euVatRates,
  getBillingStateForPastDue: () => getBillingStateForPastDue,
  getPlanPriceCents: () => getPlanPriceCents,
  getPlanStorageBytes: () => getPlanStorageBytes,
  getRecommendedPlan: () => getRecommendedPlan,
  getVatAmountCents: () => getVatAmountCents,
  isBillableRole: () => isBillableRole,
  isEuCountry: () => isEuCountry,
  isPlanId: () => isPlanId,
  isStorageExceeded: () => isStorageExceeded,
  isSubscriptionEntitled: () => isSubscriptionEntitled,
  normalizeSeats: () => normalizeSeats,
  pastDueLockAfterMs: () => pastDueLockAfterMs,
  pastDueRestrictAfterMs: () => pastDueRestrictAfterMs,
  planCurrency: () => planCurrency,
  planIds: () => planIds,
  saasPlans: () => saasPlans,
  sellerCountry: () => sellerCountry,
  storageGB: () => storageGB,
  storageMB: () => storageMB,
  storageTB: () => storageTB
});
module.exports = __toCommonJS(plans_exports);
var import_classes = require("./classes");
const storageMB = 1e3 * 1e3;
const storageGB = 1e3 * storageMB;
const storageTB = 1e3 * storageGB;
const planIds = ["free", "team", "business"];
const saasPlans = {
  free: {
    id: "free",
    basePriceCents: 0,
    seatPriceCents: 0,
    includedSeats: 1,
    minSeats: 1,
    maxSeats: 1,
    baseStorageBytes: 200 * storageMB,
    storagePerSeatBytes: 0,
    canInvite: false,
    vipSupport: false
  },
  team: {
    id: "team",
    basePriceCents: 0,
    seatPriceCents: 999,
    includedSeats: 0,
    minSeats: 1,
    baseStorageBytes: 0,
    storagePerSeatBytes: 500 * storageMB,
    canInvite: true,
    vipSupport: false
  },
  business: {
    id: "business",
    basePriceCents: 49900,
    seatPriceCents: 499,
    includedSeats: 50,
    minSeats: 50,
    baseStorageBytes: 1 * storageTB,
    storagePerSeatBytes: 500 * storageMB,
    canInvite: true,
    vipSupport: true
  }
};
const planCurrency = "EUR";
function isPlanId(value) {
  return value === "free" || value === "team" || value === "business";
}
__name(isPlanId, "isPlanId");
function normalizeSeats(plan, seats) {
  const def = saasPlans[plan];
  let result = Math.floor(seats ?? def.minSeats);
  if (!Number.isFinite(result) || result < def.minSeats) result = def.minSeats;
  if (def.maxSeats !== void 0 && result > def.maxSeats) result = def.maxSeats;
  return result;
}
__name(normalizeSeats, "normalizeSeats");
function getPlanPriceCents(plan, seats) {
  const def = saasPlans[plan];
  const s = normalizeSeats(plan, seats);
  return def.basePriceCents + def.seatPriceCents * Math.max(0, s - def.includedSeats);
}
__name(getPlanPriceCents, "getPlanPriceCents");
function getPlanStorageBytes(plan, seats) {
  const def = saasPlans[plan];
  const s = normalizeSeats(plan, seats);
  return def.baseStorageBytes + def.storagePerSeatBytes * Math.max(0, s - def.includedSeats);
}
__name(getPlanStorageBytes, "getPlanStorageBytes");
function getRecommendedPlan(seats) {
  if (seats <= 1) return "free";
  return getPlanPriceCents("business", seats) <= getPlanPriceCents("team", seats) ? "business" : "team";
}
__name(getRecommendedPlan, "getRecommendedPlan");
const billableRoles = [
  import_classes.AccountRole.Owner,
  import_classes.AccountRole.Maintainer,
  import_classes.AccountRole.User,
  import_classes.AccountRole.Guest,
  import_classes.AccountRole.DocGuest
];
function isBillableRole(role) {
  return role != null && billableRoles.includes(role);
}
__name(isBillableRole, "isBillableRole");
const pastDueRestrictAfterMs = 7 * 24 * 60 * 60 * 1e3;
const pastDueLockAfterMs = 30 * 24 * 60 * 60 * 1e3;
function getBillingStateForPastDue(pastDueSince, now = Date.now()) {
  const elapsed = now - pastDueSince;
  if (elapsed >= pastDueLockAfterMs) return "locked";
  if (elapsed >= pastDueRestrictAfterMs) return "restricted";
  return "past_due";
}
__name(getBillingStateForPastDue, "getBillingStateForPastDue");
function isSubscriptionEntitled(sub, now = Date.now()) {
  if (sub.status === "active" || sub.status === "trialing" || sub.status === "past_due") return true;
  if (sub.status === "canceled" && sub.periodEnd != null && sub.periodEnd > now) return true;
  return false;
}
__name(isSubscriptionEntitled, "isSubscriptionEntitled");
function computeWorkspaceLimits(params) {
  const { workspaceUuid, billing, seatsUsed, storageUsedBytes } = params;
  const now = params.now ?? Date.now();
  const subscription = params.subscription != null && isSubscriptionEntitled(params.subscription, now) && isPlanId(params.subscription.plan) ? params.subscription : void 0;
  const comped = billing?.comped === true;
  let plan = "free";
  let seats = 1;
  let storageLimitBytes = saasPlans.free.baseStorageBytes;
  let priceCents = 0;
  if (subscription !== void 0 && isPlanId(subscription.plan) && subscription.plan !== "free") {
    plan = subscription.plan;
    seats = normalizeSeats(plan, subscription.quantity);
    storageLimitBytes = getPlanStorageBytes(plan, seats);
    priceCents = getPlanPriceCents(plan, seats);
  } else if (comped) {
    plan = "team";
    seats = null;
    storageLimitBytes = null;
  }
  if (billing?.seatsOverride != null) seats = billing.seatsOverride;
  if (billing?.storageOverrideBytes != null) storageLimitBytes = billing.storageOverrideBytes;
  const paymentRequired = !comped && subscription === void 0 && billing?.paymentRequired === true;
  if (paymentRequired) {
    seats = 1;
    storageLimitBytes = 0;
  }
  const state = comped ? "ok" : billing?.state ?? "ok";
  const canInvite = !paymentRequired && state !== "restricted" && state !== "locked" && (comped || saasPlans[plan].canInvite) && (seats === null || seatsUsed < seats);
  return {
    workspaceUuid,
    plan,
    comped,
    paymentRequired,
    seats,
    seatsUsed,
    storageLimitBytes,
    storageUsedBytes,
    canInvite,
    state,
    stateSince: billing?.stateSince ?? null,
    subscriptionId: subscription?.id,
    subscriptionStatus: subscription?.status,
    provider: subscription?.provider,
    periodEnd: subscription?.periodEnd ?? null,
    willCancelAt: subscription?.willCancelAt ?? null,
    priceCents
  };
}
__name(computeWorkspaceLimits, "computeWorkspaceLimits");
function isStorageExceeded(limits, extraBytes = 0) {
  return limits.storageLimitBytes !== null && limits.storageUsedBytes + extraBytes > limits.storageLimitBytes;
}
__name(isStorageExceeded, "isStorageExceeded");
const sellerCountry = "DE";
const euVatRates = {
  AT: 20,
  BE: 21,
  BG: 20,
  HR: 25,
  CY: 19,
  CZ: 21,
  DK: 25,
  EE: 24,
  FI: 25.5,
  FR: 20,
  DE: 19,
  GR: 24,
  HU: 27,
  IE: 23,
  IT: 22,
  LV: 21,
  LT: 21,
  LU: 17,
  MT: 18,
  NL: 21,
  PL: 23,
  PT: 23,
  RO: 21,
  SK: 23,
  SI: 22,
  ES: 21,
  SE: 25
};
function isEuCountry(country) {
  return country != null && euVatRates[country.toUpperCase()] !== void 0;
}
__name(isEuCountry, "isEuCountry");
function computeVat(country, vatIdValid) {
  const c = (country ?? "").toUpperCase();
  if (c === sellerCountry) return { ratePercent: euVatRates[sellerCountry], treatment: "domestic" };
  if (isEuCountry(c)) {
    if (vatIdValid) return { ratePercent: 0, treatment: "reverse-charge" };
    return { ratePercent: euVatRates[c], treatment: "oss" };
  }
  return { ratePercent: 0, treatment: "non-eu" };
}
__name(computeVat, "computeVat");
function getVatAmountCents(netCents, ratePercent) {
  return Math.round(netCents * ratePercent / 100);
}
__name(getVatAmountCents, "getVatAmountCents");
//# sourceMappingURL=plans.js.map
